import { getByGeomGUIDAndSide, saveFactors } from "./services";

export async function getByGeomGUIDAndSideAction({ commit }, payload) {
  try {
    return (await getByGeomGUIDAndSide(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function saveFactorsAction({ commit }, payload) {
  try {
    await saveFactors(payload);
  } catch (e) {
    console.log(e);
  }
}
